@use "@fukuri-admins/ui/layout" as *;

.formContainer {
  display: flex;
  flex-direction: column;
  gap: spacing('16');
}

.itemSection {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
}

.itemSectionLabel {
  @include typography('Jp/14_W6');
  color: text('High');
}

.radioLabel {
  display: flex;
  align-items: center;
  gap: spacing('8');
  @include typography('Jp/14_W3');
  color: text('High');
  cursor: pointer;

  input[type='radio'] {
    cursor: pointer;
  }
}

.itemContent {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
  padding-left: spacing('24');
}

.fileInputWrapper {
  position: relative;
}

.hiddenFileInput {
  display: none;
}

.fileInputLabel {
  display: inline-block;
  padding: spacing('8') spacing('12');
  background-color: background('Tertiary');
  color: text('High');
  border-radius: borderRadius('md');
  cursor: pointer;
  @include typography('Jp/12_W6');
  text-align: center;

  &:hover {
    opacity: 0.8;
  }
}

.fileInputText {
  @include typography('Jp/12_W3');
  color: text('Middle');
}

.fileSelectedContainer {
  display: flex;
  align-items: center;
  gap: spacing('8');
  padding: spacing('8') spacing('12');
  background-color: background('Tertiary');
  border-radius: borderRadius('md');
  max-width: 100%;
}

.fileName {
  @include typography('Jp/12_W3');
  color: text('High');
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.removeButton {
  background: none;
  border: none;
  color: text('Middle');
  cursor: pointer;
  font-size: 16px;
  padding: 0;

  &:hover {
    color: text('High');
  }
}

.errorMessage {
  @include typography('Jp/12_W3');
  color: text('Red');
}

.buttonContainer {
  display: flex;
  justify-content: flex-end;
  gap: spacing('8');
}
